export const DOC_LABELS = [
  { value: 'quote', label: 'Quote' },
  { value: 'invoice', label: 'Invoice' },
  { value: 'packing_slip', label: 'Packing slip' },
  { value: 'receipt', label: 'Receipt' },
  { value: 'other', label: 'Other' },
];
export const MAX_DOC_BYTES = 25 * 1024 * 1024;
export const DOC_ACCEPT = '.pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png';
export const HEIC_HELP = "HEIC/HEIF photos (the iPhone camera default) can't be attached. Please upload a PDF, JPG or PNG. On iPhone you can switch Settings > Camera > Formats to 'Most Compatible', or share the photo as JPG.";

export const defaultLabelFor = (source) => (source === 'receive' ? 'packing_slip' : source === 'create' ? 'quote' : 'invoice');

// Client-side pre-check; the server re-validates the actual file contents.
export const checkDocFile = (file) => {
  const name = (file.name || '').toLowerCase();
  const type = (file.type || '').toLowerCase();
  if (/\.(heic|heif)$/.test(name) || type.includes('heic') || type.includes('heif')) return HEIC_HELP;
  if (!/\.(pdf|jpe?g|png)$/.test(name)) return `"${file.name}" is not a supported file type. Please upload a PDF, JPG or PNG.`;
  if (file.size === 0) return `"${file.name}" is empty.`;
  if (file.size > MAX_DOC_BYTES) return `"${file.name}" is larger than 25 MB, the limit per file.`;
  return null;
};

export const formatBytes = (n) => (n >= 1048576 ? `${(n / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);

export const apiErrorText = (err, fallback) => {
  const d = err?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (err?.response?.status === 413) return 'That file is larger than 25 MB, the limit per file.';
  return fallback;
};
